var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.034,
    height: 15.173,
    viewBox: "0 0 18.034 15.173",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money_1_",
    "data-name": "money (1)",
    transform: "translate(0.1 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1010",
    "data-name": "Group 1010",
    transform: "translate(12.382 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1009",
    "data-name": "Group 1009"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_787",
    "data-name": "Path 787",
    d: "M296.839,34.019a2.448,2.448,0,0,0,0,4.9,2.459,2.459,0,0,0,2.456-2.456A2.434,2.434,0,0,0,296.839,34.019Zm0,4.357a1.909,1.909,0,1,1,1.918-1.9A1.917,1.917,0,0,1,296.839,38.376Z",
    transform: "translate(-294.4 -34.019)",
    fill: "#f49124",
    stroke: "#f49124",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1012",
    "data-name": "Group 1012",
    transform: "translate(14.031 0.858)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1011",
    "data-name": "Group 1011"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_788",
    "data-name": "Path 788",
    d: "M335.165,56.387a.44.44,0,0,0-.051-.135.423.423,0,0,0-.067-.118c-.034-.034-.05-.067-.084-.1a.3.3,0,0,0-.118-.084.421.421,0,0,0-.118-.067c-.05-.017-.084-.05-.135-.067a1.162,1.162,0,0,1-.135-.05.128.128,0,0,1-.067-.034c-.017-.017-.05-.017-.067-.034s-.051-.017-.067-.034l-.05-.05a.087.087,0,0,1-.034-.067.1.1,0,0,1-.017-.067v-.084c0-.017.017-.05.017-.067.017-.017.017-.05.034-.067l.05-.05a.128.128,0,0,1,.084-.034.152.152,0,0,1,.084-.017h.1a.152.152,0,0,1,.084.017.731.731,0,0,1,.084.017c.017,0,.05.017.067.017.034,0,.05.017.067.017l.084.034.017-.1.034-.269v-.067l-.067-.017c-.017,0-.05-.017-.067-.017s-.034-.017-.067-.017a.729.729,0,0,0-.084-.017c-.034,0-.05-.017-.084-.017h-.017v-.32h-.4v.336h-.017a.6.6,0,0,0-.151.067.3.3,0,0,0-.118.084.727.727,0,0,0-.1.118.338.338,0,0,0-.067.135l-.051.151a.574.574,0,0,0-.017.168.371.371,0,0,0,.017.135.442.442,0,0,0,.051.135c.017.034.05.084.067.118.034.034.05.067.084.1a.3.3,0,0,0,.118.084.422.422,0,0,0,.118.067,1,1,0,0,1,.135.067,1.157,1.157,0,0,1,.135.05.128.128,0,0,1,.067.034c.017.017.05.017.067.034s.034.034.05.034l.051.05c.017.017.017.034.034.067a.728.728,0,0,1,.017.084v.084a.128.128,0,0,1-.034.067l-.05.05a.233.233,0,0,1-.067.05c-.017.017-.051.017-.067.034a.728.728,0,0,1-.084.017h-.219a.728.728,0,0,1-.084-.017.239.239,0,0,1-.1-.034c-.034-.017-.067-.017-.1-.034-.017,0-.034-.017-.05-.017s-.034-.017-.05-.017l-.1-.05-.017.118-.034.3v.05l.051.017a.225.225,0,0,1,.151.017.312.312,0,0,0,.118.034c.034.017.084.017.135.034a.37.37,0,0,0,.135.017h.034V57.6h.4v-.353h.017a.6.6,0,0,0,.151-.067.591.591,0,0,0,.135-.084.73.73,0,0,0,.1-.118.942.942,0,0,0,.084-.135l.051-.151a.519.519,0,0,0,.017-.168A.371.371,0,0,0,335.165,56.387Z",
    transform: "translate(-333.6 -54.419)",
    fill: "#f49124",
    stroke: "#f49124",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(2.881 5.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1013",
    "data-name": "Group 1013",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_789",
    "data-name": "Path 789",
    d: "M79.252,155.672a.286.286,0,0,0-.387-.05l-2.725,2.17-3.516-1.464a.268.268,0,0,0-.252.034L68.6,159.054a.269.269,0,0,0-.067.37.245.245,0,0,0,.219.118.271.271,0,0,0,.151-.05l3.651-2.608,3.533,1.464a.3.3,0,0,0,.269-.034l2.843-2.254A.286.286,0,0,0,79.252,155.672Z",
    transform: "translate(-68.489 -155.569)",
    fill: "#f49124",
    stroke: "#f49124",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(0 6.376)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1015",
    "data-name": "Group 1015"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_790",
    "data-name": "Path 790",
    d: "M17.58,193.677H16.335v-7.789a.266.266,0,0,0-.269-.269H13.593a.266.266,0,0,0-.269.269v7.789h-.908v-5.1a.266.266,0,0,0-.269-.269H9.657a.266.266,0,0,0-.269.269v5.1H8.479v-5.5a.266.266,0,0,0-.269-.269H5.737a.266.266,0,0,0-.269.269v5.5H4.559v-3.92a.266.266,0,0,0-.269-.269H1.8a.266.266,0,0,0-.269.269v3.92H.269a.269.269,0,0,0,0,.538H17.563a.266.266,0,0,0,.269-.269A.243.243,0,0,0,17.58,193.677ZM4,193.677H2.069v-3.651H4Zm3.937,0H6.006v-5.232H7.941Zm3.92,0H9.926v-4.828H11.86Zm3.937,0H13.862v-7.52H15.8Z",
    transform: "translate(0 -185.619)",
    fill: "#f49124",
    stroke: "#f49124",
    strokeWidth: 0.2
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.15132b6f9a56df73795bb365eaf32adc.svg";
export { ForwardRef as ReactComponent };